import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'

function statSlider() {
  const stats = document.querySelector('[data-name="stats"]')
  const statSliders = document.querySelectorAll('.stat-slider')

  if (statSliders.length > 0) {
    // Starting point
    statSliders.forEach((statSlider) => {
      function initializeSwiper() {
        // Counting the number of slides
        const slidesCount = statSlider.querySelectorAll('.swiper-slide').length

        let swiper

        // Check the number of slides and enable/disable the slider accordingly
        if (slidesCount >= 4) {
          swiper = new Swiper(statSlider, {
            modules: [Navigation],
            loop: true,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            slidesPerView: 1,
            slidesPerGroup: 1,
            slidesPerColumn: 1,
            spaceBetween: 40,
            speed: 1000,
            breakpoints: {
              992: {
                slidesPerView: 3,
              },
            },
          })
        } else {
          // Disable the slider entirely if there are 2 or 3 slides
          statSlider.classList.add('disabled-slider')
        }
      }

      // Initialize Swiper when the function is called
      initializeSwiper()

      // Also re-initialize when the window is resized
      window.addEventListener('resize', initializeSwiper)
    })
  }
}

export default statSlider
